<template>
  <div id="app">
    <Header
      v-if="
        $route.name !== 'AdvertiseDetails' && $route.name !== 'OutsideAdvertise'
      "
    />
    <div style="min-height: calc(100vh - 502px)">
      <router-view />
    </div>
    <Footer
      v-if="
        $route.name !== 'AdvertiseDetails' && $route.name !== 'OutsideAdvertise'
      "
    />
  </div>
</template>

<script>
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
</style>
